export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/taxonomy.worker.82d55877.js");
}
